module.exports = require("element-ui");